module.exports.ALL_BLOG_CATEGORIES_LABEL = 'all'
